import { render, staticRenderFns } from "./fpdj.vue?vue&type=template&id=3d0c1835&scoped=true"
import script from "./fpdj.vue?vue&type=script&lang=js"
export * from "./fpdj.vue?vue&type=script&lang=js"
import style0 from "./fpdj.vue?vue&type=style&index=0&id=3d0c1835&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0c1835",
  null
  
)

export default component.exports